import { Alert } from '@app/common/components/Notifier';

export type ServerError = { messages: Array<string> };
export type ServerErrors = Array<ServerError>;

export const mapErrorsToAlerts = (errors: ServerErrors) => errors.reduce(
  (acc: Array<Alert>, curr: ServerError) => [
    ...acc,
    ...curr.messages.map((title) => ({
      level: 'error',
      title,
    } as Alert)),
  ],
  [],
);
